import { NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth.service';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';

export function initializeApp(authService: AuthService) {
  return (): Observable<any> => {
    return authService.init(environment.auth);
  };
}

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot({
      config: {
        authority: environment.auth.oidc.authority,
        redirectUrl: environment.auth.oidc.redirectUri || window.location.origin,
        clientId: environment.auth.oidc.clientId || '',
        responseType: environment.auth.oidc.responseType || 'code',
        scope: environment.auth.oidc.scope || 'openid profile email',
        postLogoutRedirectUri: environment.auth.logoutRedirectUri || window.location.origin,
        silentRenew: true,
        useRefreshToken: true,
        silentRenewUrl: window.location.origin + '/assets/silent-renew.html',
        logLevel: LogLevel.Debug,
        // Paramètres de logout Keycloak
        customParamsEndSessionRequest: {
          client_id: environment.auth.oidc.clientId || '',
        },
      },
    }),
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(AuthService));
      return initializerFn();
    }),
  ],
  exports: [AuthModule],
})
export class CaaksAuthModule {
  constructor(@Optional() @SkipSelf() parentModule: CaaksAuthModule) {
    if (parentModule) {
      throw new Error(
        'AuthModuleOidcModule a déja été chargé. Vous ne devez importer les modules Core que dans AppModule',
      );
    }
  }
}
